/* tslint:disable */

declare var Object: any;
export interface StorageSettingsInterface {
  "name": string;
  "storageType": string;
  "isActive"?: boolean;
  "filesystemConfig"?: any;
  "nasConfig"?: any;
  "s3Config"?: any;
  "metadata"?: any;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  "deletedAt"?: Date;
}

export class StorageSettings implements StorageSettingsInterface {
  "name": string;
  "storageType": string;
  "isActive": boolean;
  "filesystemConfig": any;
  "nasConfig": any;
  "s3Config": any;
  "metadata": any;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;

  constructor(data?: StorageSettingsInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageSettings`.
   */
  public static getModelName() {
    return "StorageSettings";
  }

  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageSettings for dynamic purposes.
  **/
  public static factory(data: StorageSettingsInterface): StorageSettings{
    return new StorageSettings(data);
  }

  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageSettings',
      plural: 'StorageSettings',
      path: 'StorageSettings',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "storageType": {
          name: 'storageType',
          type: 'string'
        },
        "isActive": {
          name: 'isActive',
          type: 'boolean',
          default: false
        },
        "filesystemConfig": {
          name: 'filesystemConfig',
          type: 'any'
        },
        "nasConfig": {
          name: 'nasConfig',
          type: 'any'
        },
        "s3Config": {
          name: 's3Config',
          type: 'any'
        },
        "metadata": {
          name: 'metadata',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}